import React from "react";
import "./HeadSection.css"; // Create a separate CSS file or add styles accordingly
import { useNavigate } from "react-router-dom";
import useScrollToTop from "../MyComponents/hooks/useScrollToTop";
import API_CONFIG from "../config/api";

const HeadSection = ({
  leftImg,
  rightImg,
  titlePart1,
  titlePart2,
  description,
  button1Text,
  button2Text,
  button1Icon,
  button2Icon,
  onButton1Click,
  // onButton2Click,
}) => {
  const navigate = useNavigate();
  const scrollToTop = useScrollToTop();

  const handleNavigation = (path) => {
    navigate(path);
    scrollToTop();
  };

  return (
    <section className="summer-camp-hero">
      <div className="shero-wrapper">
        <div className="shero-left">
          {leftImg && <img src={`${API_CONFIG.IMAGES_URL}/${leftImg}`} alt="Left Illustration" />}
        </div>

        <div className="shero-content">
          <h1 className="shero-title">
            <span className="stitle-part1">{titlePart1}</span>
            <br />
            <span className="stitle-part2">{titlePart2}</span>
          </h1>

          <p className="shero-description">{description}</p>

          <div className="shero-buttons">
            {button1Text && (
              <button className="custom-btn orange-btn" onClick={onButton1Click}>
                {button1Icon && (
                  <img src={`${API_CONFIG.IMAGES_URL}/${button1Icon}`} alt="icon" className="sbtn-icon" />
                )}
                {button1Text}
              </button>
            )}

            {button2Text && (
              <button className="custom-btn yellow-btn" onClick={() => window.open("https://backend.polymath-kids.com/public/Documents/POLYMATH%20WINTER%20CAMPS.pdf", "_blank")}>
                {button2Icon && (
                  <img src={`${API_CONFIG.IMAGES_URL}/${button2Icon}`} alt="icon" className="sbtn-icon" />
                )}
                {button2Text}
              </button>
            )}
          </div>
        </div>

        <div className="shero-right">
          {rightImg && <img src={`${API_CONFIG.IMAGES_URL}/${rightImg}`} alt="Right Illustration" />}
        </div>
      </div>
    </section>
  );
};

export default HeadSection;
